import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePermissions, type UserPermissions } from '../hooks/usePermissions';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
    requiredPermission?: keyof UserPermissions;
    children?: React.ReactNode;
}

export function ProtectedRoute({ requiredPermission, children }: ProtectedRouteProps) {
    const { user, loading: authLoading } = useAuth();
    const { canAccess, loading: permsLoading } = usePermissions();

    if (authLoading || permsLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredPermission && !canAccess(requiredPermission)) {
        // Si no tiene permiso, redirigir a dashboard (o a una página de acceso restringido)
        return <Navigate to="/dashboard" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
}

export default ProtectedRoute;
